<div
  [attr.data-e2e]="'form:currency-select'"
  *ngIf="(currencyList$ | async).length > 1 || isDesignMode"
>
  <div
    class="ds-info mb-3"
    *ngIf="(currencyList$ | async).length === 1 && isDesignMode"
    i18n="@@one_currency_selection_will_not_show"
  >
    Diese Komponente ist nur sichtbar, wenn für das ausgewählte Produkt mehr als
    eine Währung hinterlegt ist.
  </div>

  <div class="input-container d-flex">
    <div>
      <p-dropdown
        class="form-control form-control-no-validation"
        [formControl]="form"
        [options]="currencyList$ | async"
        optionLabel="label"
        optionValue="code"
      >
        <ng-template pTemplate="selectedItem">
          <div
            class="currency-item currency-item-value"
            *var="selectedCurrency$ | async as currency"
          >
            {{ currency?.label }}
          </div>
        </ng-template>

        <ng-template let-currency pTemplate="item">
          <div class="currency-item">
            {{ currency.label }}
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>
</div>
